import { Component, ViewEncapsulation, HostBinding, ChangeDetectionStrategy } from '@angular/core';

/** Shown when sign-in is refused because the tenant is in maintenance mode and the user is not a System Administrator. */
@Component({
    selector: 'maintenance-tenant',
    templateUrl: 'maintenance.tenant.component.html',
    styleUrls: ['maintenance.tenant.component.less'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true
})
export class MaintenanceTenantComponent {

    @HostBinding('class.modern-form') modern = true;
}
